import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router'; 
//import { AuthConstants } from 'src/app/config/auth-constants';
import { StoreService } from 'src/app/services/store.service';
import { ToastService } from 'src/app/services/toast.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';


@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  ionicForm: FormGroup;
  isSubmitted = false;
  email: any;
  password: any;
  productId: any;
  promotionId: any;
  productQty: any;
  authKey: any;
  pattern: any;
  email1: any;
  userId : any;
  skipData :any={};
  role : any;
   test : any;
   color : any;
   colorp : any;
  passwordType: string = 'password';
 passwordIcon: string = 'eye-off';
 public type = 'password';
public showPass = false;
  constructor(private formBuilder: FormBuilder, private toast: ToastService, private router: Router, private authService: StoreService ) {
    this.ionicForm = this.formBuilder.group({
      email: ['', [Validators.required]],
      // email: ['', [Validators.required, Validators.email, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      password: ['', [Validators.required]]
    });
  }
  get errorControl() {
    return this.ionicForm.controls;
    
  }
  ngOnInit() {
    
  }
  register() {
    //this.router.navigate(['/signup'])
    let navigationParams: NavigationExtras = { state: { isLoginWithOTPFlag: "0" } };
    this.router.navigate(['/signup'], navigationParams);
  }
  
  submitForm() {
    // Code added by Divyansh Sharma on 28/02/22 to present the toast and change the color of field on invalid field
    if(this.ionicForm.controls.email.errors?.required ){
      this.color="red";
      console.log("aa")
      this.toast.presentToast("Please enter email or mobile number");
    }
    else{
      this.color=""
      console.log("bb")
    }
    if(this.ionicForm.controls.password.errors?.required  ){
      this.colorp="red";
      console.log("aa")
      this.toast.presentToast("Please enter your password");
    }
    else{
      this.colorp=""
      console.log("bb")
    }
    //this.authService.showLoader()
    this.pattern = new RegExp('[a-z0-9]+@[a-z]+\.[a-z]{2,3}[^\s]|(^[0-9]{10})+$');
    this.email1 = this.ionicForm.value.email.trim()

    this.isSubmitted = true;
    if (!this.ionicForm.valid) {
      console.log('Please provide all the required values!')
     // this.authService.hideLoader()
      return

    } 
    else if(!this.pattern.test(this.email1)){
      this.toast.presentToast("Please enter valid email or Phone no");
    }
    else {
     // this.authService.showLoader()
      // console.log(this.ionicForm.value)
      // 1 for IOS
      // 2 for android
      //  console.log("pushtokenValue--00>>"+this.localdataArray.getLocalData('device', 'pushToken')+"-->>"+this.localdataArray.getLocalData('device', 'deviceType'));
      const Loginobj = {
        email: this.ionicForm.value.email.trim(),
        pwd: this.ionicForm.value.password,
        pushToken:localStorage.getItem('pushToken'),
        deviceType:0
        // deviceToken: localStorage.getItem('pushToken') ? localStorage.getItem('pushToken') : 'PpQY0WpuXi1F3VKQ0MLDsfcU0vMpS4',
        //pushToken: (this.localdataArray.getLocalData('device', 'pushToken') ? this.localdataArray.getLocalData('device', 'pushToken') : 'PpQY0WpuXi1F3VKQ0MLDsfcU0vMpS4'),
        // deviceType: localStorage.getItem('deviceType') ? localStorage.getItem('deviceType') : '1',
        //  deviceType: (this.localdataArray.getLocalData('device', 'deviceType') ? this.localdataArray.getLocalData('device', 'deviceType') : '1')
        //  deviceType:0
      }
      console.log("pushtokenValue--11>>", JSON.stringify(Loginobj));
      //console.log("pushtokenValue--22>>"+this.localdataArray.getLocalData('device', 'pushToken'));
      //this.http.post(APIS.loginMobile, Loginobj, false).subscribe((result: any) => {
      this.authService.login(Loginobj).subscribe((result: any) => {
        console.log("response from login aPI", result)
        this.userId=result.userId;
        //this.authService.hideLoader()
        if (result.code == 0) {
          this.toast.presentToast(result.msg)
        } else if (result.code == 1) {
          this.toast.presentToast(result.msg)
        }
        else if (result.code == 2) {
          this.toast.presentToast(result.msg)
        } else {
          //this.navCtrl.setRoot('TabsPage');
          localStorage.setItem("role",'0');
          localStorage.setItem("userId", this.userId)
          //this.storageService.store('login', "login")
          //this.storageService.store(AuthConstants.AUTH_USERDATA, this.userId)
          //this.storage.set("userId", this.userId)
          let navigationParams: NavigationExtras = { state: {flag:'login'}};
          this.router.navigate(['/'],navigationParams)
        }
      }, (error: any) => {
        //this.authService.hideLoader()
        this.toast.presentToast("there is error in login time")
      })
    }
    
    
  }
//this function not in use so dont do in this function
  login() {
    //this.authService.showLoader()
    // 1 for IOS
    // 2 for android
    //  console.log("pushtokenValue--00>>"+this.localdataArray.getLocalData('device', 'pushToken')+"-->>"+this.localdataArray.getLocalData('device', 'deviceType'));
    const Loginobj = {
      email: this.email,
      pwd: this.password,
      pushToken:localStorage.getItem('pushToken'),
      deviceType:0
      // deviceToken: localStorage.getItem('pushToken') ? localStorage.getItem('pushToken') : 'PpQY0WpuXi1F3VKQ0MLDsfcU0vMpS4',
      //pushToken: (this.localdataArray.getLocalData('device', 'pushToken') ? this.localdataArray.getLocalData('device', 'pushToken') : 'PpQY0WpuXi1F3VKQ0MLDsfcU0vMpS4'),
      // deviceType: localStorage.getItem('deviceType') ? localStorage.getItem('deviceType') : '1',
      //  deviceType: (this.localdataArray.getLocalData('device', 'deviceType') ? this.localdataArray.getLocalData('device', 'deviceType') : '1')
     
    }
    console.log("send login form datapushtokenValue--11>>", JSON.stringify(Loginobj));
    //console.log("pushtokenValue--22>>"+this.localdataArray.getLocalData('device', 'pushToken'));
    //this.http.post(APIS.loginMobile, Loginobj, false).subscribe((result: any) => {
    console.log("send login page email and password", )
    this.authService.login(Loginobj).subscribe((result: any) => {
      console.log("resposne from login aPI", result)
      
      //this.authService.hideLoader()
      if (result.code == 0) {
        this.toast.presentToast(result.msg)
      } else if (result.code == 1) {
        this.toast.presentToast(result.msg)
      }
      else if (result.code == 2) {
        this.toast.presentToast(result.msg)

      } else {
        //this.navCtrl.setRoot('TabsPage');
        localStorage.setItem("userId", result.userId)
        localStorage.setItem("role",null);
        localStorage.setItem("name",result.email)
        //this.storageService.store(AuthConstants.AUTH_USERDATA, result.userId)
        let navigationParams: NavigationExtras = { state: {flag:'login'}};
        this.router.navigate(['/'],navigationParams)
      }
    }, (error: any) => {
      this.toast.presentToast("there is error in login time")
    });
  }
  // loginAction(){
  //   console.log(this.postData)
  //   this.authService.login(this.postData).subscribe((res:any)=>{
  //    console.log("Login response",res)
  //     if(res.id){
  //       this.storageService.store(AuthConstants.AUTH_USERDATA,res.id)
  //        this.router.navigate(['/home/feed'])
  //     }else{
  //       this.toast.presentToast("Incorrect user is and password")
  //     }
  //   },(error:any)=>{
  //     console.log("Network connection error",error)
  //   })
  // }
  forgotPassword() {
    this.router.navigate(['/forgot-passwordd'])
  }
  DemoDeals() {
    this.router.navigate(['/demo-offers'])
  }
  LoginWithOtp() {
    let navigationParams: NavigationExtras = { state: { isLoginWithOTPFlag: "1" } };
    this.router.navigate(['/signup'], navigationParams);
  }
  customerIssue() {
    this.router.navigate(['/customer-issue'])
  }
  hideShowPassword() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    console.log(this.passwordType)
    // this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
}
showPassword() {
  this.showPass = !this.showPass;
  if(this.showPass){
    this.type = 'text';
  } else {
    this.type = 'password';
  }
}
// Added by Divyansh Sharma for guest login(bug no. 956) on 31/01/2022
// skipLogin(){
//   this.authService.guestLogin("").subscribe(res=>{
//     console.log(res);
//     this.skipData=res;
//     console.log(this.skipData.msg[0]._id);
//     this.userId=this.skipData.msg[0]._id;
//     this.role=this.skipData.msg[0].role;
//     this.storage.set("userId", this.userId);
//     this.storage.set("role",this.role);
//     console.log(this.userId,"userid");
//     console.log(this.role,"role");
//     //this.storageService.store(AuthConstants.AUTH_USERDATA, this.userId)
//     let navigationParams: NavigationExtras = { state: {flag:'login'}};
//     this.router.navigate(['/home/feed'])
    
//   })
// }

}
